"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.ErrorCode = {
    UNKNOWN: 'UNKNOWN',
    AMAZON_SP_API_ERROR: 'AMAZON_SP_API_ERROR',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    MISSING_QUANTITY_PER_BOX: 'MISSING_QUANTITY_PER_BOX',
    DSKU_NEVER_INBOUNDED: 'DSKU_NEVER_INBOUNDED',
    SKU_NOT_FOUND_IN_CATALOG: 'SKU_NOT_FOUND_IN_CATALOG',
    SHIPMENT_NOT_FOUND_LOGIWA: 'SHIPMENT_NOT_FOUND_LOGIWA',
    INVALID_SKU: 'INVALID_SKU',
    UNEXPECTED_WAREHOUSE_CANCELLATION: 'UNEXPECTED_WAREHOUSE_CANCELLATION',
    NO_WAREHOUSE_FOUND_CONTAINING_INVENTORY_FOR_ALL_ITEMS: 'NO_WAREHOUSE_FOUND_CONTAINING_INVENTORY_FOR_ALL_ITEMS',
    INTENDED_WAREHOUSE_CANCELLATION: 'INTENDED_WAREHOUSE_CANCELLATION',
    REJECTED_DUE_TO_INVENTORY_STRATEGY: 'REJECTED_DUE_TO_INVENTORY_STRATEGY',
    ISSUE_INGESTING_INVENTORY: 'ISSUE_INGESTING_INVENTORY',
    REJECTED_DUE_TO_QUANTITY_STRATEGY: 'REJECTED_DUE_TO_QUANTITY_STRATEGY',
    PARCEL_ACCEDED_WEIGHT_LIMIT: 'PARCEL_ACCEDED_WEIGHT_LIMIT',
    FREIGHT_UNDER_MINIMUM_WEIGHT: 'FREIGHT_UNDER_MINIMUM_WEIGHT',
    SELLER_NOT_ELIGIBLE_FOR_WHOLESALE: 'SELLER_NOT_ELIGIBLE_FOR_WHOLESALE'
};
//# sourceMappingURL=error-code.js.map